import Vue from 'vue'
import Vuex from 'vuex'
import Auth from '../mixins/auth';

//Modules
import App from './modules/app/appModule'
import error from './modules/errorModule';
import Navigation from './modules/navigation'
import Service from './modules/services'
import Authorization from './modules/authorization'
import User from './modules/user'
import Role from './modules/role'
import Notify from './modules/notificationModule'
import MasterData from './modules/masterData/masterData'
import Person from './modules/person'
import Factory from './modules/factory'
import Contact from './modules/contact'
import Search from './modules/search'
import PigSty from './modules/pigSty'
import ArticleGroup from './modules/article/articleGroup'
import TestPig from './modules/article/testPig';
import Article from './modules/article/article';
import DeliveryProperty from './modules/delivery/deliveryProperty';
import ArticleDefinition from "./modules/article/articleDefinition";
import Addition from "./modules/addition/addition";
import unit from "./modules/masterData/unit";
import lockTypes from './modules/masterData/accountingLock';
import accounting from './modules/accounting/accounting';
import numberRange from './modules/masterData/numberRange';
import slaughterHouse from './modules/person/slaughterHouse';
import deliveryProgram from './modules/delivery-program/deliveryProgram';
import deliveryProgramParameter from "@/store/modules/delivery-program/deliveryProgramParameter";
import pigPrice from "@/store/modules/pig-price/pigPrice";
import pigPriceCategory from "@/store/modules/pig-price/pigPriceCategory";
import pigCalendar from '@/store/modules/pig-calendar/pigCalendarModule';
import summaryAddition from "@/store/modules/summary-addition/summaryAddition";
import deliverySet from "@/store/modules/delivery/deliverySet";
import deliverySetComplete from "@/store/modules/delivery/delivery-set-complete-module";
import deliveryRemark from "@/store/modules/delivery/deliveryRemark";
import comment from "@/store/modules/comment/commentModule";
import factoryDeliveryProgram from "@/store/modules/person/factoryDeliveryProgram";
import userSetting from './modules/user-setting/user-setting-module';
import registrationGroup from './modules/pig-registration/pigRegistrationGroupModule'
import registrationSet from './modules/pig-registration/pigRegistrationSetModule'
import registrationCapacity from './modules/pig-registration/pigRegistrationCapacityModule'
import transporter from "./modules/transporter/transporter-module";
import transport from './modules/transport/transport-module';
import reporting from './modules/reporting/reporting-module';
import config from './modules/config/config-module';
import earmark from './modules/earmark/earmarkModule';
import earmarkAccounting from './modules/earmark/earMarkAccountingModule';
import earmarkDefaultPrice from './modules/earmark/earmarkDefaultPriceModule';
import earmarkElba from './modules/earmark/earmarkElba';
import deliverySetClearing from './modules/delivery/delivery-set-clearing-module';
import individualReportModule from './modules/article/individualReportModule';
import individualReportResultModule from './modules/article/individualReportResultModule';
import individualReportArticle from './modules/article/individualReportArticleModule';
import pigletDelivery from './modules/pig-let/pigletDelivery';
import pigletDeliveryAddition from './modules/pig-let/pigletDeliveryAddition';
import pigletAddition from './modules/pig-let/pigletAddition';
import pigletTransport from './modules/pig-let/pigletTransport';
import pigletArticle from './modules/pig-let/pigletArticle';
import pigletPaymentSlip from './modules/pig-let/pigletPaymentSlip';
import keyListener from './modules/keylistener/KeyListener';
import pigletQuantityScale from './modules/pig-let/pigletQuantityScale';
import pigletMarketingFee from './modules/pig-let/pigletMarketingFee';
import pigletPrint from "@/store/modules/pig-let/pigletPrint";
import hubConnections from "@/store/modules/hubs/HubConnectionModule";
import blob from "@/store/modules/blob/blobModule";
import blobGroup from "@/store/modules/blob/blobGroupModule";
import jobs from "@/store/modules/jobs/job-module";
import babyPigletPriceFormula from '@/store/modules/baby-piglet/priceFormulaModule';
import RouterSubscription from "@/store/modules/router/RouterSubscription";
import pigletDeliveryUnit from "@/store/modules/pig-let/pigletDeliveryUnit";
import pigletHireTransaction from "@/store/modules/pig-let/pigletHireTransaction";
import pigletRegstriation from "@/store/modules/pig-registration/piglet/PigletRegistration";
import pigletRegistrationTransport from "./modules/pig-registration/piglet/PigletTransport";
import pigletRegistrationOrder from "./modules/pig-registration/piglet/PigletOrder";
import registrationDeadline from './modules/pig-registration/deadline/RegistrationDeadline';
import businessIdentifiers from "./modules/masterData/businessIdentifiers";
import slaughterInvoice from './modules/delivery/slaughter-invoice';
import version from './modules/version/version';
import freighter from "./modules/delivery/freighter";
import manualReason from './modules/masterData/manualReasons';
import manualDocument from './modules/masterData/manualDocument';
import zsdbPiglet from './modules/pig-let/pigletZsdb';
import pigletAccountingPackage from './modules/pig-let/pigletAccountingPackage';
import zsdbPigSty from './modules/article/zsdbModule';
import pigStyAccountingPackage from './modules/article/accountingPackage';

Vue.use(Vuex);
let store = new Vuex.Store({
  modules: {
    app: App,
    error,
    config,
    navigation: Navigation,
    service: Service,
    authorization: Authorization,
    user: User,
    role: Role,
    notify: Notify,
    masterData: MasterData,
    person: Person,
    factory: Factory,
    contact: Contact,
    search: Search,
    pigSty: PigSty,
    articleGroup: ArticleGroup,
    testPig: TestPig,
    article: Article,
    deliveryProperty: DeliveryProperty,
    articleDefinition: ArticleDefinition,
    addition: Addition,
    unit: unit,
    lockTypes,
    accounting,
    numberRange,
    slaughterHouse,
    deliveryProgram,
    deliveryProgramParameter,
    deliverySetComplete,
    pigPrice,
    pigPriceCategory,
    pigCalendar,
    summaryAddition,
    deliverySet,
    deliveryRemark,
    comment,
    factoryDeliveryProgram,
    userSetting,
    registrationGroup,
    registrationSet,
    registrationCapacity,
    transporter,
    transport,
    reporting,
    earmark,
    earmarkAccounting,
    earmarkDefaultPrice,
    earmarkElba,
    deliverySetClearing,
    individualReportModule,
    individualReportResultModule,
    individualReportArticle,
    pigletDelivery,
    pigletDeliveryAddition,
    pigletAddition,
    pigletTransport,
    pigletArticle,
    pigletPrint,
    pigletPaymentSlip,
    keyListener,
    pigletQuantityScale,
    pigletMarketingFee,
    hubConnections,
    blob,
    blobGroup,
    jobs,
    babyPigletPriceFormula,
    routerSubscription: RouterSubscription,
    pigletDeliveryUnit,
    pigletHireTransaction,
    pigletRegstriation,
    pigletRegistrationTransport,
    pigletRegistrationOrder,
    registrationDeadline,
    businessIdentifiers,
    slaughterInvoice,
    version,
    freighter,
    manualReason,
    manualDocument,
    zsdbPiglet,
    pigletAccountingPackage,
    zsdbPigSty,
    pigStyAccountingPackage
  }
});

store.$auth = Auth;

export default  store;

